import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PEV } from "../../../common/utils";
import * as service from "./service";

const initialState = {
  userGroupsListForUserView: PEV({
    userGroups: [],
    userGroupTypes: [],
  }),
};

export const getUserGroupsListForUserView = createAsyncThunk(
  "userGroupListForUserView/get",
  async (selectedUserId) => {
    return await service.getUserGroupsListForUserView(selectedUserId);
  }
);

const userGroupsListForUserViewSlice = createSlice({
  name: "userGroupListForUserView",
  initialState,
  reducers: {},
  extraReducers: {
    [getUserGroupsListForUserView.pending.type]: (state, action) => {
      state.userGroupsListForUserView = PEV(
        initialState.userGroupsListForUserView.value,
        "Fetching user group list"
      );
    },
    [getUserGroupsListForUserView.fulfilled.type]: (state, action) => {
      let userGroupsListForUserView = action.payload;
      state.userGroupsListForUserView = PEV(userGroupsListForUserView);
    },
    [getUserGroupsListForUserView.rejected.type]: (state, action) => {
      state.userGroupsListForUserView = PEV(
        initialState.userGroupsListForUserView.value,
        null,
        "Error while fetching user group list"
      );
    },
  },
});

export const UserGroupsListForUserViewReducer = userGroupsListForUserViewSlice.reducer;
export const UserGroupsListForUserViewActions = { getUserGroupsListForUserView };
